module.exports = "<p>\n  buy works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/buy/buy.component.html
// module id = ../../../../../src/app/buy/buy.component.html
// module chunks = main